<template>
  <div class="card shadow" style="position: relative">
    <GStockLoader :loading="loading" />
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">{{ "Corbeille" }}</h3>
          <b-form-input
            v-model="search"
            size="sm"
            class="mr-sm-2"
            placeholder="Chercher produit par nom"
          ></b-form-input>
        </div>

        <div class="col text-right">
          <!-- v-if="aPayer > 0" -->
          <!-- <base-button
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            size="sm"
            v-if="admin"
            @click="addCredit"
            >Crédit</base-button
          > -->
          <!-- <b-dropdown
            id="dropdown-1"
            text="Actions"
            class="m-md-2 mr-10"
            style="min-width: 200px"
          >
            <b-dropdown-item v-if="!canceled" @click="printBarCodes"
              >Imprimer code à barre</b-dropdown-item
            >
            <b-dropdown-item v-if="!canceled" @click="setStatus(1)"
              >Vente / Livraison</b-dropdown-item
            >
            <b-dropdown-item v-if="!canceled" @click="setStatus(2)"
              >En attente de paiement</b-dropdown-item
            >
            <b-dropdown-item v-if="!canceled" @click="setStatus(0)"
              >Rétablir le statut par défaut</b-dropdown-item
            >
            <b-dropdown-item @click="bulkDelete">Supprimer</b-dropdown-item>
            <b-dropdown-item v-if="!canceled" @click="bulkCancel"
              >Annuler</b-dropdown-item
            >
            <b-dropdown-item v-if="canceled" @click="bulkReactivate"
              >Réactiver</b-dropdown-item
            >
          </b-dropdown> -->
          <!-- <base-button
            style="
              background-color: #000;
              width: 150px;
              height: 50px;
              color: #fff;
            "
            size="sm"
            v-b-modal.modal-ajoutprod
            >Ajouter</base-button
          > -->
        </div>
      </div>
      <!-- <div class="row align-items-center" style="margin-top: 5px" v-if="admin">
        <div class="col">
          <h3 class="mb-0">Total en main : {{ enMain }} DT</h3>
        </div>
        <div class="col">
          <h3 class="mb-0">Crédit client : {{ client.credit }} DT</h3>
        </div>
        <div class="col">
          <h3 class="mb-0">Total à payer : {{ aPayer }} DT</h3>
        </div>
      </div> -->
    </div>

    <base-table
      striped
      class="table striped align-items-center"
      tbody-classes="list"
      :data="items"
    >
      <template slot="columns">
        <th>
          <b-form-checkbox
            v-model="selectAll"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </th>
        <th>Réf</th>
        <th>Article</th>
        <th>Attributs</th>
        <th>Prix</th>
        <th>Crédit</th>
        <th>Prix en main</th>
        <th>Status</th>
        <th>Déposant</th>
        <th>Date de dépot</th>
        <th></th>
        <th></th>
      </template>

      <template slot-scope="{ row }">
        <td>
          <b-form-checkbox
            v-model="selections[row.id]"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </td>
        <td class="budget" style="cursor: pointer" @click="openProduct(row.id)">
          {{ row.id }}
        </td>
        <td style="cursor: pointer" @click="openProduct(row.id)">
          {{ row.name }}
        </td>
        <td style="cursor: pointer" @click="openProduct(row.id)">
          <div v-if="row.attributes">
            <div v-for="(attr, ind) in row.attributes.split(';')" :key="ind">
              {{ attr.split("(:)")[0] }} : {{ attr.split("(:)")[1] }}
            </div>
          </div>
        </td>
        <td style="cursor: pointer" @click="openProduct(row.id)">
          {{ row.price }} DT
        </td>
        <td class="budget" style="cursor: pointer" @click="openProduct(row.id)">
          {{ row.credit ? "Oui" : "Non" }}
        </td>
        <td style="cursor: pointer" @click="openProduct(row.id)">
          {{ (row.price * (1 - row.percentage)).toFixed(2) }} DT
        </td>

        <td style="cursor: pointer" @click="openProduct(row.id)">
          {{
            row.canceled
              ? "Annulé"
              : row.purchased == 1
              ? "Vendu"
              : "Disponible"
          }}
        </td>
        <td style="cursor: pointer" @click="openProduct(row.id)">
          {{ row.client.name }}
        </td>
        <td style="cursor: pointer" @click="openProduct(row.id)">
          {{ $options.filters.date(row.createdOn) }}
        </td>
        <td class="text-actions">
          <!-- <b-button
            size="sm"
            @click="
              current = row.id;
              print();
            "
            class="mr-2"
            >Code à barre</b-button
          > -->
          <!-- <b-button
            size="sm"
            v-if="row.purchased == 1 && row.canceled != 1 && row.paid == 1"
            @click="regularity(row)"
            class="mr-2"
            >Reçu de reglement</b-button
          > -->
          <div></div>
          <!-- <b-button
            size="sm"
            @click="pay(row.id)"
            class="mr-2"
            v-if="row.purchased == 1 && row.canceled != 1 && row.paid != 1"
            >Payer</b-button
          > -->
          <!-- <b-button
            size="sm"
            @click="printDeliveryBill(row)"
            class="mr-2 mt-1"
            v-if="row.delivered == 1"
            >Bon livraison</b-button
          >
          <b-button
            size="sm"
            @click="showConfirmCancelPurchase(row.id)"
            class="mr-2"
            v-if="row.purchased == 1 && row.canceled != 1 && row.paid != 1"
            >Annuler vente</b-button
          >
          <div
            v-show="printingCode[row.id]"
            :id="'bar-code-' + row.id"
            style="display: inline-block; background-color: white"
          >
            <center>
              <barcode
                :value="'(' + row.id + ') ' + row.price + 'DT'"
                :options="{
                  lineColor: '#000',
                  text: '(' + row.id + ') ' + row.price + 'DT',
                  fontOptions: 'bold',
                  fontSize: 30,
                }"
              ></barcode>
              <br />
              <strong
                ><b style="font-size: 24px !important; color: black">{{
                  row.name
                }}</b></strong
              >
              <br /><strong
                ><b style="font-size: 24px; color: black">{{
                  getDate(row.createdOn)
                }}</b></strong
              >
            </center>
          </div> -->
        </td>

        <td class="text-right">
          <base-dropdown
            class="dropdown"
            position="right"
            v-if="row.purchased != 1 || row.canceled == 1"
          >
            <a
              slot="title"
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </a>

            <!-- <template>
              <a class="dropdown-item" @click="duplicateProduct(row)" href="#"
                >Dupliquer</a
              >
              <a class="dropdown-item" @click="updateProduct(row)" href="#"
                >Modifier</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click="showConfirm(row.id)"
                v-b-modal.modal-1
                >Supprimer</a
              >
              <a
                v-if="row.canceled == 0"
                class="dropdown-item"
                href="#"
                @click="showConfirmCancel(row.id)"
                v-b-modal.modal-1
                >Annuler</a
              >
              <a
                v-if="row.canceled == 1"
                class="dropdown-item"
                href="#"
                @click="showConfirmCancel(row.id, 0)"
                v-b-modal.modal-1
                >Reactiver</a
              >
              <a
                v-if="row.canceled != 1 && row.purchased != 1"
                class="dropdown-item"
                href="#"
                @click="openStatusChange(row.id)"
                v-b-modal.modal-1
                >Changer le statut</a
              >
            </template> -->
          </base-dropdown>
        </td>
      </template>
    </base-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <div
      class="row align-items-center"
      style="margin-top: 5px; margin-left: 10px"
      v-if="admin"
    >
      <div class="col">
        <h3 class="mb-0">Total en main : {{ enMain }} DT</h3>
      </div>

      <div class="col">
        <h3 class="mb-0">Total à payer : {{ aPayer }} DT</h3>
      </div>
    </div>
    <!-- <div>
      <ModalUpdateProduit
        ref="updateproduct"
        @added="reset"
      ></ModalUpdateProduit>
      <ModalDetailProduit ref="showdetails"></ModalDetailProduit>
      <ModalAddProduit @added="reset"></ModalAddProduit>
      <ModalUpdateProductStatus @updated="reset" ref="updateStatus" />
      <UpdateClientCredit @updated="reset" ref="updateCredit" />
    </div> -->
    <!-- <b-modal id="modal-delete" hide-footer title="Sypprimer produit">
      <p class="my-4">Voulez vous supprimer</p>
      <hr class="my-4" />
      <center>
        <b-btn type="submit" style="background-color: #c2b59b; color: #fff"
          >non</b-btn
        >
        <b-btn type="submit" style="background-color: #c2b59b; color: #fff"
          >oui</b-btn
        >
      </center>
    </b-modal> -->
    <!-- <div id="barcodes-all" v-show="printall">
      <BarCodes ref="allBarcodes" :products="selectedBarCodes" />
    </div>
    <div id="printable-client-bill" v-show="printing">
      <DeliveryBill :products="selectedProducts" ref="delivery" />
    </div>
    <div id="printable-client-bill" v-show="false">
      <reglement-bill
        :name="selectedName"
        :article="selcetedArticleName"
        :total="selectedArticleTotal"
        ref="regularity"
      />
    </div> -->
    <!-- <img
      :src="imgSrc"
      v-show="false"
      width="310px"
      height="142px"
      id="printable"
    /> -->
  </div>
</template>
<script>
import ModalUpdateProduit from "../Produit/ModalUpdateProduit";
import ModalDetailProduit from "../Produit/DetailProduit";
import ModalAddProduit from "../Produit/ModalAjoutProduit";
import ModalUpdateProductStatus from "./ModalUpdateProductStatus";
import UpdateClientCredit from "./UpdateClientCredit";
import debounce from "lodash/debounce";
import { post, get, del, put } from "@/mixins/api";
import printJS from "print-js";
import { EventBus } from "@/events/event-bus";
import GStockLoader from "@/components/Loader";
import DeliveryBill from "@/components/DeliveryBill";
import BarCodes from "@/components/BarCodes";
import ReglementBill from "../../components/ReglementBill.vue";

export default {
  name: "ClientTable",
  components: {
    ModalUpdateProduit,
    ModalDetailProduit,
    ModalAddProduit,
    ModalUpdateProductStatus,
    UpdateClientCredit,
    DeliveryBill,
    GStockLoader,
    BarCodes,
    ReglementBill,
  },
  props: {
    canceled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedName: "",
      selcetedArticleName: "",
      selectedArticleTotal: 0,
      user: JSON.parse(localStorage.getItem("user")),
      values: [],
      currentPage: 1,
      perPage: 20,
      canLoadMore: true,
      category: 0,
      loadedProducts: {},
      currentProduct: { photos: [] },
      canGoNext: true,
      data: {
        data: [],
        count: 0,
      },
      search: "",
      prefix: "productsArchived",
      current: 0,
      imgSrc: "",
      currentProduct: {},
      admin: false,
      statsByOwner: {},
      loading: false,
      selectedProducts: [],
      printing: false,
      client: {},
      printingCode: {},
      selections: {},
      selectAll: false,
      printall: false,
    };
  },
  computed: {
    rows() {
      return this.data.count;
    },
    items() {
      return this.data.data;
    },
    enMain() {
      return this.statsByOwner.enMain;
    },
    aPayer() {
      return this.statsByOwner.aPayer - this.client.credit;
    },
    selectedIds() {
      return Object.keys(this.selections).filter((_) => this.selections[_]);
    },
    selectedBarCodes() {
      return this.items.filter((_) =>
        this.selectedIds.some((id) => id == _.id)
      );
    },
  },
  methods: {
    duplicateProduct(product) {
      console.log("product.id", product.id);
      const { id } = product;
      this.loading = true;
      post("duplicateProduct/" + id)
        .then((res) => {
          console.log("duplicateProduct");
          console.log("res:", res);
          this.getProducts();
        })
        .catch((err) => {
          this.makeToast("Une erreur est survenue merci de résseayez.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    regularity(product) {
      this.selectedName = product.client.name;
      this.selcetedArticleName = product.name;
      this.selectedArticleTotal = product.price;
      setTimeout(() => {
        this.$refs.regularity.printMe();
      }, 0);
    },
    printBarCodes() {
      this.printall = true;
      setTimeout(() => {
        this.printall = false;
        printJS({
          printable: "barcodes-all",
          type: "html",
          header: "",
        });
      }, 500);
    },
    setStatus(status) {
      const selectedStatus =
        status == 1 ? "delivered" : status == 2 ? "topay" : "reset";
      const model = {
        delivered: selectedStatus == "delivered",
        topay: selectedStatus == "topay",
      };
      let promises = [];
      this.selectedIds.forEach((id) => {
        promises = [...promises, put("product/status/" + id, model)];
      });
      Promise.all(promises).then(() => {
        this.reset(true);
      });
    },
    bulkDelete() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Vous confirmez que vous allez supprimer ces articles ?",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          let promises = [];
          if (value) {
            this.selectedIds.forEach((id) => {
              promises = [...promises, del("product/" + id)];
            });
            Promise.all(promises).then(() => {
              this.reset(true);
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    bulkCancel() {
      const val = 1;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Voulez-vous vraiement " +
            (val == 1 ? "annuler" : "réactiver") +
            " ces articles",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          const url = val == 1 ? "product/cancel" : "product/activate";
          if (value) {
            let promises = [];
            this.selectedIds.forEach((id) => {
              promises = [...promises, put(url + "/" + id)];
            });
            Promise.all(promises).then(() => {
              this.reset(true);
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    bulkReactivate() {
      const val = 2;
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Voulez-vous vraiement " +
            (val == 1 ? "annuler" : "réactiver") +
            " ces articles",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          const url = val == 1 ? "product/cancel" : "product/activate";
          if (value) {
            let promises = [];
            this.selectedIds.forEach((id) => {
              promises = [...promises, put(url + "/" + id)];
            });
            Promise.all(promises).then(() => {
              this.reset(true);
            });
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    getDate(date) {
      const dDate = new Date(date);
      const day = dDate.getDate() > 9 ? dDate.getDate() : "0" + dDate.getDate();
      const realMonth = dDate.getMonth() + 1;
      const month = realMonth > 9 ? realMonth : "0" + realMonth;
      const year = dDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
    addCredit() {
      this.$refs.updateCredit.setId(
        this.client.id,
        this.client.credit,
        this.aPayer
      );
    },
    printDeliveryBill(product) {
      this.selectedProducts = [product];
      this.$refs.delivery.printMe();
    },
    openStatusChange(id) {
      this.$refs.updateStatus.setId(id);
    },
    updateProduct(item) {
      this.$refs.updateproduct.showMe(item);
    },
    pay(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Voulez vous vraiment confirmer le paiement de cet article ?",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value)
            put("product/pay/" + id).then((result) => {
              this.reset(true);
            });
        })
        .catch((err) => {
          // An error occurred
        });
    },
    openProduct(id) {
      EventBus.$emit("lookForProduct", id);
    },
    print() {
      this.printingCode[this.current] = true;
      this.printingCode = Object.assign({}, this.printingCode);
      setTimeout(() => {
        printJS({
          printable: "bar-code-" + this.current,
          type: "html",
          header: "",
        });
        this.printingCode[this.current] = false;
        this.printingCode = Object.assign({}, this.printingCode);
      }, 500);
    },
    getProducts: debounce(function () {
      this.loading = true;
      post(
        `${this.prefix}/${this.perPage}/${
          this.perPage * (this.currentPage - 1)
        }`,
        {
          name: this.search,
        }
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.loadedProducts[this.currentPage] = this.data.data;
      });
    }, 1000),
    showConfirm(id) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Vous confirmez que vous allez supprimer cet article ?",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value)
            del("product/" + id).then((res) => {
              this.reset(true);
            });
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showConfirmCancel(id, val = 1) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Voulez-vous vraiement " +
            (val == 1 ? "annuler" : "réactiver") +
            " cet article",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          const url = val == 1 ? "product/cancel" : "product/activate";
          console.log(val, url);
          if (value)
            put(url + "/" + id).then((res) => {
              this.reset(true);
            });
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showConfirmCancelPurchase(id) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Voulez-vous vraiement annuler le vente de cet article",
          {
            title: "Confirmez Svp!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "OUI",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value)
            get("purchase/getProduct/" + id).then((res) => {
              del("purchase/" + res.data.data).then(() => {
                this.reset(true);
              });
            });
        })
        .catch((err) => {
          // An error occurred
        });
    },
    reset() {
      post(
        `${this.prefix}/${this.perPage}/${
          this.perPage * (this.currentPage - 1)
        }`,
        {
          name: "",
        }
      ).then((res) => {
        this.data = res.data;
        this.loadedProducts[this.currentPage] = this.values;
      });
      if (this.admin) {
        get("client/" + this.client.id).then((res) => {
          this.client = res.data.data;
        });
      }
    },
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Ajout produit.",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        if (Object.keys(this.loadedProducts).some((key) => key == newVal)) {
          this.data.data = this.loadedProducts[newVal];
        } else {
          this.getProducts();
        }
      },
    },
    search: {
      handler: function (newVal) {
        this.loadedProducts = {};
        this.getProducts();
      },
    },
    selectAll: {
      handler: function (newVal) {
        if (!newVal) {
          Object.keys(this.selections).forEach(
            (_) => (this.selections[_] = false)
          );
        } else {
          const allPageItems = this.items.slice(
            this.perPage * (this.currentPage - 1),
            this.perPage
          );
          allPageItems.forEach((_) => (this.selections[_.id] = true));
        }
        this.selections = Object.assign({}, this.selections);
      },
    },
  },
  filters: {
    date: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const tmp = date.toLocaleDateString("fr-FR", { weekday: "long" });
      const day = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      const month = date.toLocaleString("fr-FR", { month: "long" });
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      let currentHour = date.getHours() + "";
      let currentMinute = date.getMinutes() + "";
      if (currentHour.length < 2) currentHour = "0" + currentHour;
      if (currentMinute.length < 2) currentMinute = "0" + currentMinute;
      return (
        day +
        " " +
        dayOfMonth +
        " " +
        month +
        " " +
        year +
        ", " +
        currentHour +
        ":" +
        currentMinute
      );
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.prefix = "productByOwner/" + id;
      this.admin = true;
      get("statsByOwner/" + id).then((res) => {
        this.statsByOwner = res.data;
      });
      get("client/" + id).then((res) => {
        this.client = res.data.data;
      });
    }
    if (this.canceled) {
      this.prefix = "canceledProducts";
    }
    this.getProducts();
  },
};
</script>
<style lang="scss">
.customBarCodes div {
  font-size: 24px;
}
.customP {
  font-weight: bold;
  font-size: 24px !important;
  color: #000;
  margin: 0 !important;
  padding: 0px !important;
}
td,
th {
  //   max-width: min-content;
  //   padding: 0.75em !important;
  //   @media (max-width: 1474px) {
  //     padding: 0.5em !important;
  //   }
  //   @media (max-width: 1394px) {
  //     padding: 0.3em !important;
  //   }
}
.btn-primary {
  background-color: #000;
  border-color: #000;
}
.page-item {
  &.active {
    .page-link {
      background-color: #000;
      border-color: #000;
    }
  }
}
#printable {
  display: none;
}

@media print {
  * {
    display: none;
  }
  #printable {
    display: block;
  }
}
</style>
